



























import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldOnsiteSpacePricing'

  vue:
    props: ['value', 'errors', 'options']

    data: ->
      spaces: @value || []
      spacesClone: JSON.parse(JSON.stringify(@value || '[]'))
      priceInDollars: {}
      feeInDollars: {}
      payoutInDollars: {}

    computed:
      currentSpaceSegment: ->
        @options?.currentSpaceId

      currentSpace: -> 
        @spaces.find((space) => space.segment is @currentSpaceSegment) 

      pricingTableData: ->
        sizes = ['10x10', '10x20', '20x40', '40x60']
        { size: size, } for size in sizes

    mounted: ->
      @initializePriceInDollars()

    methods:
      initializePriceInDollars: ->
        price = {}
        fee = {}
        payout = {}
        for row in @pricingTableData
          space = @spaces.find((s) => s.size is row.size)
          if space?.size and space?.price_in_cents
            price[space.size] = space.price_in_cents / 100
            fee[space.size] = @calculateFeeForSpace space
            payout[space.size] = @calculatePayoutForSpace space
          price[row.size] ||= null
          fee[row.size] ||= 0
          payout[row.size] ||= 0
        @priceInDollars = price
        @feeInDollars = fee
        @payoutInDollars = payout

      inputChanged: ->
        @$emit 'input', @spaces

      hiInputChange: ->
        # @preventInvalidValueForCurrentSpace()
        @pruneEmptyValues()
        @$emit 'change', @spaces

      preventInvalidValueForCurrentSpace: -> # deprecated
        space = @spaces.find((s) => s.segment is @currentSpaceSegment)
        spaceCloned = @spacesClone.find((s) => s.segment is @currentSpaceSegment)
        return unless space
        return unless spaceCloned
        space.price_in_cents = spaceCloned.price_in_cents if space.price_in_cents <= 0

      pruneEmptyValues: ->
        @spaces = @spaces.filter((space) =>
          return true if space.price_in_cents > 0
          false
        )

      hiSetPriceInCentsForSpaceSize: (spaceSize, costInDollars) ->
        costInDollars = costInDollars.replace /,/g, ''
        @priceInDollars[spaceSize] = costInDollars
        priceInCents = parseInt(parseFloat(costInDollars || '0') * 100)
        space = @spaces.find((s) => s.size is spaceSize)

        if space
          space.price_in_cents = priceInCents
        else
          space =
            size: spaceSize
            price_in_cents: priceInCents
          @spaces.push space
        @calculateFeeForSpace space
        @calculatePayoutForSpace space
        @inputChanged()

      calculateFeeForSpace: (space) ->
        @feeInDollars[space.size] = @feeForSpaceInCents(space) / 100

      feeForSpaceInCents: (space) ->
        spaceType = @spaceTypeForSize(space.size)
        priceInCents = parseInt(space.price_in_cents || '0')
        takePercentage = @standardPricingTable()[spaceType]?.take_percentage || 0
        feeInCents = priceInCents * takePercentage / 100
        feeInCents

      calculatePayoutForSpace: (space) ->
        @payoutInDollars[space.size] = @payoutForSpaceInCents(space) / 100

      payoutForSpaceInCents: (space) ->
        spaceType = @spaceTypeForSize(space.size)
        priceInCents = parseInt(space.price_in_cents || '0')
        payoutInCents = priceInCents - @feeForSpaceInCents(space)
        payoutInCents

      spaceTypeForSize: (spaceSize) ->
        "space_#{spaceSize}"

    watch:
      value: (v) ->
        @spaces = v

export default VueOptions.vue settings
